export default {
    meta: {
        title: '加签',
        url: '/approval',
        urlName: '审批-通用流程' // 埋点字段，上报归属的模块
    }
};
